import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

interface IMenuItem {
  text: string;
  handleClick: () => void;
  icon?: React.ReactNode;
  dataAction?: string;
}

interface IProps {
  anchorEl: HTMLElement | null;
  isOpen: boolean;
  onClose: () => void;
  dataAction: string;
  menuItems: IMenuItem[];
}

export const DropdownMenu: React.FC<IProps> = ({ anchorEl, isOpen, onClose, dataAction, menuItems }) => {
  const iconElement = useCallback((icon: React.ReactNode) => {
    if (!icon) {
      return null;
    }
    return (
      <ListItemIcon>
        {React.cloneElement(icon as React.ReactElement, {
          sx: { width: 20, height: 20, color: 'action.active', mr: 2 },
        })}
      </ListItemIcon>
    );
  }, []);

  const menuItemsElements = useMemo(() => {
    return menuItems.map((item, index) => (
      <MenuItem
        key={index}
        onClick={() => {
          item.handleClick();
          onClose();
        }}
        data-action={item.dataAction || `dropdown_menu_${dataAction}_${index}`}
        sx={{ px: 2, py: '6px' }}
      >
        {iconElement(item.icon)}
        <ListItemText
          slotProps={{
            primary: { sx: { fontSize: '14px', lineHeight: '24px' } },
          }}
        >
          {item.text}
        </ListItemText>
      </MenuItem>
    ));
  }, [menuItems, dataAction, onClose, iconElement]);

  return (
    <Menu
      id="add-address-menu"
      anchorEl={anchorEl}
      open={isOpen}
      onClose={onClose}
      sx={{ '& .MuiPaper-root': { borderRadius: 0.5 } }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {menuItemsElements}
    </Menu>
  );
};
